<template>
  <b-modal v-model="isShow" title="Có phải merchant mới theo chính sách TPV?">
    <div v-if="isLoading" class="my-2 text-center">
      <b-spinner class="align-middle"></b-spinner>
    </div>
    <div v-else>
      <a
        aria-controls="collapse-4"
        class="m-1 text-danger wrap-text"
        href="#"
        @click="isVisible = !isVisible"
        v-if="messageWarning.length > 0"
      >
        Cảnh báo trùng mã số kinh doanh và địa điểm kinh doanh (Ấn vào xem chi tiết)
      </a>
      <div v-if="messageWarning.length > 0">
        <b-collapse
          id="collapse-4"
          v-model="isVisible"
          style="overflow-x: hidden; overflow-y: auto"
        >
          <div class="warning-wrapper scroll-list">
            <b-card>
              <small
                class="text-muted d-block mt-1"
                v-for="(message, index) in messageWarning"
                :key="index"
              >
                {{ message }}
              </small>
            </b-card>
          </div>
        </b-collapse>
      </div>
    </div>
    <template #modal-footer>
      <template v-if="!isLoading">
        <div class="d-flex justify-content-between align-items-center w-100">
          <template v-if="checkedDuplicateGpkd">
            <div style="max-width: 250px">
              <span class="text-red">*</span> <i>Bấm "xác nhận" để sinh phiếu</i>
              <br />
              <i> thẩm định chi nhánh mới </i>
            </div>
            <div>
              <b-button variant="primary" @click="handleApprove(false)"> Xác nhận </b-button>
            </div>
          </template>
          <template v-else>
            <div style="max-width: 250px">
              <span class="text-red">*</span><i>Có: MC được ghi nhận là MC mới</i>
              <br />
              <span class="text-red"> * </span>
              <i> Không: MC được ghi nhận là MC cũ và sinh phiếu thẩm định chi nhánh mới </i>
            </div>
            <div class="">
              <b-button variant="danger" @click="handleApprove(false)">Không</b-button>
              <b-button class="ml-2" variant="success" @click="handleApprove(true)">Có</b-button>
            </div>
          </template>
        </div>
      </template>
      <template v-else> loading... </template>
    </template>
  </b-modal>
</template>

<script>
  import { ContractService } from '@/services/contract.service'

  export default {
    name: 'DkkdModal',
    props: {
      dataContract: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        isShow: false,
        isVisible: true,
        messageWarning: [],
        isLoading: false,
        checkedDuplicateGpkd: false,
        customerInfoRes: {},
        customerId: null,
        isDuplicateGpkd: false,
      }
    },
    methods: {
      hide() {
        this.isShow = false
      },
      async show() {
        this.isShow = true

        if (this.dataContract && this.dataContract.customerInfoRes) {
          this.customerInfoRes = this.dataContract.customerInfoRes
        } else if (this.dataContract && this.dataContract.customerInfoCommon) {
          this.customerInfoRes = this.dataContract.customerInfoCommon
        }
        if (this.dataContract && this.dataContract.customerId) {
          this.customerId = this.dataContract.customerId
        }
        await this.checkDuplicateGpkd()
      },
      handleApprove(option) {
        this.$emit('approve', {
          mcNewTPV: option,
        })
      },
      async checkDuplicateGpkd() {
        try {
          this.isLoading = true
          this.isVisible = true
          this.messageWarning = []
          const params = {
            gpkd: this.customerInfoRes.businessRegistrationNumber ?? '',
            addressMc: this.customerInfoRes.address ?? '',
          }
          if (this.customerId) {
            params.customerId = this.customerId
          }

          const response = await ContractService.checkDuplicateGpkd(params)
          if (response.code === 1000) {
            const messageDuplicateGpkds =
              response.data && response.data.messageDuplicateGpkds
                ? response.data.messageDuplicateGpkds
                : []
            const messageDuplicateAddress =
              response.data && response.data.messageDuplicateAddress
                ? response.data.messageDuplicateAddress
                : []
            this.messageWarning = this.messageWarning.concat(
              messageDuplicateGpkds,
              messageDuplicateAddress
            )

            this.checkedDuplicateGpkd = response.data?.isDuplicateGpkd
          } else {
            this.showFailMx(response.message ?? response.error)
          }
        } catch (e) {
          this.showFailMx(e.response?.data?.message ? e.response.data.message : e.message)
        } finally {
          this.isLoading = false
        }
      },
    },
  }
</script>

<style scoped lang="scss">
  .scroll-list {
    position: relative;
    max-height: 50vh;
    overflow-y: scroll;
  }
  .text-red {
    color: red;
  }
</style>
